import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../components/HeaderCustom";
import { Button, Container, Typography, useMediaQuery, useTheme } from "@mui/material";
import SkeletonLoading from "../../../components/SkeletonLoading";
import '../../../styles/AppCss.css'
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Padding, PaletaColor } from "../../../styles/StylesConstantes";
import { Add, Delete, Edit } from "@mui/icons-material";
import { getProductos } from "../../../api/ApiService";
import { useNavigate } from "react-router-dom";



function BeneficiosEspecialesPage() {
  const [loading, setLoading] = useState(false);
  const [dataBanners, setDataBanners] = useState([]);

  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));

  let history = useNavigate();


  useEffect(() => {
    handleListarProductos();
  }, []);

  const handleListarProductos = () => {

    getProductos(1, 100)
      .then((response) => {
        console.log("response-getProductos", response);
        if (response.body.length > 0) {
          setDataBanners(response.body);
          setLoading(true);
        } else {
          setDataBanners([]);
          setLoading(true);
        }
      })
      .catch((error) => {
        console.log("error-getProductos", error);
        setDataBanners([]);
        setLoading(true);
      });
  };


  const columns = [
    { field: 'id', headerName: 'ID', width: 90 },
    {
      field: 'nombre',
      headerName: 'Beneficio',
      width: 150,
      editable: false,
    },
    {
      field: 'fechaModificacion',
      headerName: 'Locales adheridos',
      type: 'number',
      width: 250,
      editable: false,
    },
    {
      field: 'imagen',
      headerName: 'Imagen',
      width: 250,
      editable: false,
      renderCell: (params) => (
        <img
          src={params.value}
          alt="icon"
          style={{ width: 150, height: undefined, aspectRatio: 1 }}
        />
      ),
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Acciones',
      width: 100,
      cellClassName: 'actions',
      getActions: ({ id }) => {
        return [
          <GridActionsCellItem
            icon={<Edit />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<Delete />}
            label="Delete"
            onClick={handleDeleteClick(id)}
            color="inherit"
          />,
        ];
      },
    },
  ];



  //=================================================================================================funcion para editar, obtener el id
  const handleEditClick = (id) => () => {
    console.log('Edit', id);
    history(`/app/admin/banners-detalle/${id}`, { state: null });
  };

  //=================================================================================================funcion para eliminar, obtener el id
  const handleDeleteClick = (id) => () => {
    console.log('Delete', id);
    setDataBanners(dataBanners.filter((row) => row.id !== id));
  }

  //=================================================================================================funcion para ir a la pantalla de agregar
  const handleAddCategoria = () => {
    history('/app/admin/locales-categorias-add', { state: null });
  };

  return (
    <HeaderCustom>
      <div style={{
        marginTop: Padding.P2,
        padding: Padding.P2,
      }}>
        {loading ? (
          <div style={{
            backgroundColor: PaletaColor.BLANCO,
            borderRadius: Padding.P1,
            padding: Padding.P3,
          }}>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', alignContent: 'center', marginBottom: Padding.P2 }}>
              <Typography variant={'h5'} style={{}}>
                Beneficios Especiales
              </Typography>

              <div style={{}}>
                <Button
                  fullWidth
                  variant="contained"
                  style={{
                    backgroundColor: PaletaColor.AZUL_OSCURO,
                    color: PaletaColor.BLANCO,
                    fontWeight: 'bold',
                  }}
                  startIcon={<Add />}
                  // onClick={handleAddCategoria}
                >
                  Agregar Beneficio Especial
                </Button>
              </div>
            </div>

            <DataGrid
              rows={dataBanners}
              columns={columns}
              rowHeight={100}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 5,
                  },
                },
              }}
              pageSizeOptions={[5]}
              checkboxSelection
              disableRowSelectionOnClick
            />
          </div>
        ) : (
          <Container sx={{}} style={{}}>
            <SkeletonLoading />
          </Container>
        )}
      </div>
    </HeaderCustom>
  );
}
export default BeneficiosEspecialesPage;